import {
  IconHome2,
} from "@tabler/icons";

const appLinks = [
  {
    label: "Home",
    icon: IconHome2,
    links: [
      {
        label: "Home",
        to: "/",
      },      
    ],
  },  
];
export { appLinks };
